var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var canonicalAlias = function (field) { return field.toLowerCase() === 'naturality' ? 'birthplace' : field.toLowerCase(); };
var formatValue = function (field, value) {
    if (field.type !== 'DATE')
        return value;
    var match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value);
    return match ? "".concat(match[3], "-").concat(match[2], "-").concat(match[1]) : value;
};
// Consume OCR once, so subsequent field edits and service responses keep the user's values.
export var prepareDocumentDataStep = function (form, review) {
    if (!review || review.targetStep !== undefined)
        return { form: form, review: review };
    var target = form.steps.find(function (step) { return step.type === 'FORM' && step.step > review.sourceStep; });
    if (!target)
        return { form: form, review: review };
    var values = new Map(Object.entries(review.values).map(function (_a) {
        var key = _a[0], value = _a[1];
        return [canonicalAlias(key), value];
    }));
    return {
        review: __assign(__assign({}, review), { targetStep: target.step }),
        form: __assign(__assign({}, form), { steps: form.steps.map(function (step) { return step !== target ? step : __assign(__assign({}, step), { fields: step.fields.map(function (field) {
                    var value = values.get(canonicalAlias(field.field));
                    return (value === null || value === void 0 ? void 0 : value.trim()) ? __assign(__assign({}, field), { value: formatValue(field, value) }) : field;
                }) }); }) }),
    };
};
